import { computed, defineComponent, ref, reactive } from 'vue';
import HttpRequest from '@/util/axios.config';
import { toClipboard } from '@soerenmartius/vue3-clipboard';
export default defineComponent({
    emits: ['close'],
    props: {
        baseUrl: {
            type: String,
            required: true
        },
        otherConfig: {
            type: Object,
            required: true
        }
    },
    setup(props) {
        const close = ref(false);
        const config = reactive({
            Title: ''
        });
        const isClickLink = ref(false);
        const isShowCopied = ref(false);
        const token = ref('');
        const url = computed(() => `${props.baseUrl}${token.value}`);
        const getLink = () => {
            HttpRequest.post('createToken', [{
                    Config: JSON.stringify({ ...config, ...props.otherConfig })
                }, false], (res) => {
                token.value = res.data.token;
                toClipboard(url.value);
                isShowCopied.value = true;
                setTimeout(() => {
                    isShowCopied.value = false;
                }, 2000);
            });
        };
        return {
            close,
            config,
            isClickLink,
            isShowCopied,
            token,
            url,
            getLink
        };
    }
});
